import { fork } from 'redux-saga/effects';
import watchFetchAssets from './assets/saga';

export default function* watchDomains() {
  yield fork(watchFetchAssets);
}
